import React, { useEffect, useState } from 'react';
import StepContent from '../../components/step-content';
import { PlanType } from '../../components/enums/plan-type';
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { updateFsa, updateSelection } from "../../redux/actions/enrollments-actions";
import { OptionalCheckbox, OptionalLookup, OptionalNumber, RequiredLookup, RequiredNumber } from '../../components/form_elements/form-validators';
import useMsalApi from '../../components/use-msal-api';
import FsaDependent from './fsa-dependent';
import {StructuredListSkeleton } from 'carbon-components-react';
import FsaPlanDetails from "./fsa-plan-details"
import FormCheckbox from '../../components/form_elements/form-checkbox';
import { format, parseISO } from 'date-fns';


const FSA = ({pageStep}) => {
    const [callApi] = useMsalApi();
    const dispatch = useDispatch();
    const enrollments = useSelector(s => s.enrollments);
    const [fsaDetails, setFsaDetails] = useState();
    const [loadingFsa, setLoadingFsa] = useState(true);
    const [reset, setReset] = useState(false);
    const [depedentCareSelection, setDepedentCareSelection] = useState();
    const [medicalCareSelection, setMedicalCareSelection] = useState();
    const [agreed, setAgreed] = useState(true);

    const validationSchema = Yup.object().shape({
        agreement: OptionalCheckbox(),
        dependentCareType: OptionalLookup().when("agreement", {is: true, then: RequiredLookup("Required")}),
        dependentCareYearlyAmount: OptionalNumber().test('yearly-amount', 'Required',
                (item, ctx) => {
                    return !(ctx.parent.dependentCareType === 2 && isNaN(item));
                }).test('dependent-yearly-amount', `Value cannot be greater than $${fsaDetails?.dependentCare.myYearlyMax.toLocaleString()}`,
                (item, ctx) => {
                    if(ctx.parent.dependentCareType !== 2)
                        return true;
                    return item <= fsaDetails?.dependentCare.myYearlyMax
                }
            )
        ,
        dependentCareWeeklyAmount: OptionalNumber().test('weekly-amount', 'Required',
                (item, ctx) => {
                    return !(ctx.parent.dependentCareType === 2 && isNaN(item));
                }).test('medical-yearly-amount', `Value cannot be greater than $${fsaDetails?.dependentCare.myWeeklyMax.toLocaleString()}`,
                (item, ctx) => {
                    if(ctx.parent.dependentCareType !== 2)
                        return true;
                    return item <= fsaDetails?.dependentCare.myWeeklyMax
                }
                )
        ,
        medicalType: OptionalLookup().when("agreement", {is: true, then: RequiredLookup("Required")}),
        medicalYearlyAmount: OptionalNumber().test('medical-yearly-amount', 'Required',
                (item, ctx) => {
                    return !(ctx.parent.medicalType === 2 && isNaN(item));
                }
            ).test('medical-yearly-amount', `Value cannot be greater than $${fsaDetails?.medicalCare.myYearlyMax.toLocaleString()}`,
                (item, ctx) => {
                    if(ctx.parent.medicalType !== 2 )
                        return true;
                    return item <= fsaDetails?.medicalCare.myYearlyMax
                }
            )
        ,
        medicalWeeklyAmount: OptionalNumber().test('medical-weekly-amount', 'Required',
                (item, ctx) => {
                    return !(ctx.parent.medicalType === 2 && isNaN(item));
                }
            ).test('medical-yearly-amount', `Value cannot be greater than $${fsaDetails?.medicalCare.myWeeklyMax.toLocaleString()}`,
                (item, ctx) => {
                    if(ctx.parent.medicalType !== 2)
                        return true;

                    return item <= fsaDetails?.medicalCare.myWeeklyMax
                }
        )
   });

    useEffect(() => {
        if(Array.isArray(enrollments) || fsaDetails)
            return;

        const medicalCareEnrollment = enrollments.selections?.find(s => s.planId === "MEDFLX");
        const dependentCareEnrollment =enrollments.selections?.find(s => s.planId === "DEPFLX");
        let show = false;
        if(medicalCareEnrollment?.amount || dependentCareEnrollment?.amount){
            show = true;
        }
        setAgreementChecked(show);
        toggleAgreement(show);

        const getFsaDetails = async () => {
            setLoadingFsa(true);
            var params = {
                employeeNumber: enrollments.employee.id,
                effectiveDate: enrollments.effectiveDate,
                company : enrollments.employee.company,
                enrollmentsType : enrollments.enrollmentTypeId
            }
            console.log("FSHA");
            var results = await callApi(`Fsa`, "POST", params);
            if(!results.error){
                setFsaDetails(results);

        
            }

            setLoadingFsa(false);
        }

        setMedicalCareSelection(medicalCareEnrollment);
        setDepedentCareSelection(dependentCareEnrollment);

        getFsaDetails();

    }, [enrollments,reset])

    const onSubmit = async (frm) => {
        console.log("FSA Form Submission",frm);
        let params =  [
                {
                    planId: "DEPFLX",
                    planDescription: "Flexible Depend Spending Acct",
                    planType: PlanType.DependentCareFsa,
                    amount: setAmount(frm.dependentCareType, frm.dependentCareWeeklyAmount, frm.agreement),
                    yearlyAmount: setAmount(frm.dependentCareType, frm.dependentCareYearlyAmount, frm.agreement)
                },
                {
                    planId: "MEDFLX",
                    planDescription: "Flexible Medical Spending Acct",
                    planType: PlanType.MedicalCareFsa,
                    amount: setAmount(frm.medicalType, frm.medicalWeeklyAmount, frm.agreement),
                    yearlyAmount: setAmount(frm.medicalType, frm.medicalYearlyAmount, frm.agreement)
                }
            ];

        const results = await callApi(`Enrollments/${enrollments.id}/Fsa/${enrollments.employee.id}/${format(
            parseISO(enrollments.effectiveDate),
            "yyyy-MM-dd"
          )}`, "PATCH", params);
        if(!results.error){
            dispatch(updateFsa(results));
        }
      };

    const onReset = () => {
        setReset(!reset)
    };

      const setAmount = (type, weekAmount, agreed) => {
        if(!agreed || agreed === false)
            return null;
        if(type === 3)
            return 0;
        
       return weekAmount;
      }
      const onError = (errors, e) => {
        console.log("Form Submission Error", errors);
      };
    
    const toggleAgreement = (e) => {
        console.log("toggling", e);
        setAgreed(e)
    }
    const setAgreementChecked = (val) => {
        console.log("WOJKLFDJKLDFJ", val);
        setAgreed(val)
        return val;
    }
    
    return ( 
        <>
        <StepContent pageStep={pageStep} schema={validationSchema} onSubmit={onSubmit} onError={onError} onReset={onReset}>
        <div className="flex flex-col sm:flex-row items-center mb-4 mt-2">
          <div className="text-3xl sm:mr-16">FSA</div>
          <div className="sm:mr-16"><FsaPlanDetails /></div>
        </div>
        <div>
                <FormCheckbox name="agreement" onChange={toggleAgreement} label="I elect to participate in my employer's Flexible Spending Account Plan and agree to be bound by the terms of my employer's plan. I understand that the contribution(s) I have elected will be made with pre-tax salary reductions and that such reductions reduce my compensation for Social Security benefit purposes. I understand that this agreement is only for eligible services and treatment provided during the Plan Year and that said services must be provided before the submission of claims for reimbursement. I also understand that I am making a binding election for the entire Plan Year unless I have a qualified change of status as defined by my employer's plan. Any salary deductions that have not been used for expenses incurred in the Current Plan Year may be forfeited depending on the terms of my employer's plan.
If the Plan Administrator determines that an expense I submitted for reimbursement was not a qualified expense under the Plan Documents, I shall immediately reimburse the plan for the entire amount of the unqualified expense. If I fail to timely reimburse the Plan, I understand that amounts may be withheld from wages or from otherwise valid expenses under the Plan in order to reimburse the unqualified expense." />
        </div>
            {!Array.isArray(enrollments) && !loadingFsa ?
                <>
                <FsaDependent 
                    title="Medical FSA" 
                    coverageTypeName="medicalType" 
                    contributionPeriodName="medicalContributionPeriod"
                    weeklyAmountName="medicalWeeklyAmount"
                    yearlyAmountName="medicalYearlyAmount"
                    details={fsaDetails.medicalCare} 
                    planType={PlanType.MedicalCareFsa}
                    payPeriodsUntilEffectiveDate={fsaDetails.payPeriodsUntilEffectiveDate}
                    remainingPayChecksThisYear={fsaDetails.remainingPayChecksThisYear} 
                    reset={reset}
                    enabled={agreed}
                />
                <FsaDependent 
                    title="Dependent Care FSA" 
                    coverageTypeName="dependentCareType" 
                    contributionPeriodName="dependentContributionPeriod"
                    weeklyAmountName="dependentCareWeeklyAmount"
                    yearlyAmountName="dependentCareYearlyAmount"
                    details={fsaDetails.dependentCare} 
                    planType={PlanType.DependentCareFsa}
                    payPeriodsUntilEffectiveDate={fsaDetails.payPeriodsUntilEffectiveDate} 
                    remainingPayChecksThisYear={fsaDetails.remainingPayChecksThisYear} 
                    reset={reset}
                    enabled={agreed}
                    />
                </>
            :
                <StructuredListSkeleton />
            }
        </StepContent>
        </>
     );
}
 
export default FSA;